import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";

const PopupMain = styled.main`
  flex: 1 1 auto;
  overflow: auto;
  position: relative;
  font-size: 14px;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
`;

export default PopupMain;
